import { render, staticRenderFns } from "./LinkToOrder.vue?vue&type=template&id=1954a08f&"
import script from "./LinkToOrder.vue?vue&type=script&lang=js&"
export * from "./LinkToOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports